// This will certainly be replaced with relay feeds, but hardcoded for now
export const RECOMMENDED_PUBKEYS = JSON.parse(import.meta.env.VITE_RECOMMENDED_PUBKEYS) as string[]
